import { render } from "./ProductEditComponent.vue?vue&type=template&id=1b9aefd3"
import script from "./ProductEditComponent.vue?vue&type=script&lang=js"
export * from "./ProductEditComponent.vue?vue&type=script&lang=js"

import "./ProductEditComponent.vue?vue&type=style&index=0&id=1b9aefd3&lang=css"

import exportComponent from "C:\\Users\\webencusco\\Desktop\\projects vue3\\flawyer\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__